export const specialContractType = {
  a: 'a',
} as const;
